import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_REPORTS';

const en = {
    displayReport: 'Display Report',
    displayReportTooltip: 'Open Report in Browser',
    excel: 'Download as Spreadsheet',
    excelTooltip: 'Download Report Data to Spreadsheet (e.g., Excel File)',
    file: 'Download to File',
    fileTooltip: 'Download Report Data to File (e.g., TXT file for loading',
    graph: 'Graph',
    graphTooltip: 'Display Report Data in Graph',
    table: 'Table',
    tableTooltip: 'Download Report Data as Table',
    pdf: 'PDF',
    lockedFile: 'Lock File',
    moreOptions: 'More Options',
    showLess: 'Show Less',
    design: 'Design',
    designReport: 'Design Report',
    designExcel: 'Design Excel Template',
    approve: 'OK',
    noTemplate: 'No Template',
    savedReports: 'Saved Reports',
    display: 'Display',
    send: 'Send',
    delete: 'Delete',
    blockDeletion: 'Block Deletion',
    selectExcelTemplate: 'Select your Excel template here.',
    allowDeletion: 'Allow Deletion',
    oldTemplateWarn: 'The template is in an old format and is no longer',
    selectExcelTemplateTitle: 'Excel Templates',
    savedDocuments: 'Saved Documents'
};

const he = {
    displayReport: 'הצגת הדו"ח',
    displayReportTooltip: 'פתיחת הדו"ח בדפדפן',
    excel: 'הורדה לגיליון נתונים',
    excelTooltip: 'הורדת נתוני הדו"ח לגיליון נתונים, כמו קובץ Excel',
    file: 'הורדה לקובץ',
    fileTooltip: 'הורדת נתוני הדו"ח לקובץ. למשל, קובץ TXT עבור',
    graph: 'גרף',
    graphTooltip: 'הצגת נתוני הדו"ח בגרף',
    table: 'טבלה',
    tableTooltip: 'הורדת נתוני הדו"ח בצורת טבלה',
    pdf: 'PDF',
    lockedFile: 'קובץ נעול',
    moreOptions: 'אפשרויות נוספות',
    showLess: 'להראות פחות',
    design: 'עיצוב',
    designReport: 'עיצוב דו"ח',
    designExcel: 'עיצוב תבנית אקסל',
    approve: 'אישור',
    noTemplate: 'ללא תבנית',
    savedReports: 'דו"חות שמורים',
    display: 'הצגה',
    send: 'שליחה',
    delete: 'מחיקה',
    blockDeletion: 'חסימת מחיקה',
    selectExcelTemplate: 'כאן בוחרים את תבנית ה-Excel',
    allowDeletion: 'לאפשר מחיקה',
    oldTemplateWarn: 'התבנית בפורמט ישן ואינה נתמכת יותר.',
    selectExcelTemplateTitle: 'תבניות Excel',
    savedDocuments: 'מסמכים שמורים'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'displayReport',
    2: 'displayReportTooltip',
    3: 'excel',
    4: 'excelTooltip',
    5: 'file',
    6: 'fileTooltip',
    7: 'graph',
    8: 'graphTooltip',
    9: 'table',
    10: 'tableTooltip',
    11: 'pdf',
    12: 'lockedFile',
    13: 'moreOptions',
    14: 'showLess',
    15: 'design',
    16: 'designReport',
    17: 'designExcel',
    18: 'approve',
    19: 'noTemplate',
    20: 'savedReports',
    21: 'display',
    22: 'send',
    23: 'delete',
    24: 'blockDeletion',
    25: 'selectExcelTemplate',
    26: 'oldTemplateWarn',
    27: 'allowDeletion',
    28: 'selectExcelTemplateTitle',
    29: 'savedDocuments'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
